import { useState } from "react";
const fechaActual = new Date();
const ejercicioActual = fechaActual.getFullYear();
const mesActual = fechaActual.getMonth() + 1;

const initialStatebox = {
  ejercicioinicio: ejercicioActual,
  periodoinicio: "1",
  ejerciciofin: ejercicioActual,
  periodofin: mesActual,
  arrayadr: [],
  arraysucursal: [],
  arraydepartamento: [],
  arrayvendedor:[],
  pv: { adr: [], sucursal: [], departamento: [], vendedor:[] },
};
export const useBox = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };
  // console.log(boxstate)
  return [boxstate, BoxChange, setBoxState];
};

export const useBoxFiltros = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange];
};
